import { Popover } from "@portal/BaseComponents/PopOver/AntPopOver";
import { PopoverProps } from "@portal/BaseComponents/PopOver/type";
import { FilterBlock, FilterBlockProps } from "../FilterBlock/FilterBlock";

interface FilterDropdownDownProps {
  filterBlockProps: FilterBlockProps;
  filterComponent: PopoverProps["content"];
  filterTitle: string;
  onopenChange?: PopoverProps["onOpenChange"];
}

function FilterDropdownDown(props: FilterDropdownDownProps) {
  const { filterBlockProps, filterComponent, filterTitle, onopenChange } =
    props;

  return (
    <Popover
      title={filterTitle}
      open={filterBlockProps.open}
      content={filterComponent}
      onOpenChange={onopenChange}
      arrow={false}
      placement="bottomLeft"
      trigger={["click"]}
      destroyTooltipOnHide
    >
      <FilterBlock {...filterBlockProps} />
    </Popover>
  );
}

export { FilterDropdownDown };
